import React, { useEffect } from "react";
import Loadingnovel from "../../../components/Loadingnovel";
import { useSelector, useDispatch } from "react-redux";
import { getSpecialForYou } from "../../../3- actions/novels";
import SpecialNovel from "./SpecialNovel";

function SpecialForYou({ setPopUp, setInterfaces }) {
  const dispatch = useDispatch();
  const skeleton = [{}];
  const specialNovel = useSelector((state) => state.novelsData.specialNovel);
  useEffect(() => {
    if (!specialNovel.novels) {
      dispatch(getSpecialForYou());
    }
  }, []);

  return (
    <div className="h-full px-[15px] md:px-0 sm:mt-[100px] mt-[30px] text-center 2xl:text-left 2xl:mt-0 relative w-full 2xl:w-[47%]">
      <h1 className="font-size text-tertiary">Special for you</h1>
      {specialNovel.pending === true
        ? skeleton?.map(() => {
            return (
              <div
                key={Math.random()}
                className="relative flex flex-col-reverse xl:flex-row w-full text-left 2xl:gap-x-10 2xl:py-0  2xl:h-[660px] 2xl:justify-start items-center mt-[50px] text-secondary z-10 bg-tertiary pl-0 2xl:pl-[60px]"
              >
                <div className="px-6 py-10  md:p-10 border-t-8 xl:border-t-0 border-primary lg:p-14 2xl:p-0 w-full flex flex-col justify-center text-center  xl:text-start h-1/2 2xl:w-[400px]">
                  <div className=""></div>
                  <div className=" "></div>
                  <div className="flex gap-x-6 items-center xl:justify-start justify-center"></div>
                  <div className="md:grid grid-cols-3  text-start xl:grid-cols-2 hidden justify-center  xl:justify-start items-start flex-wrap gap-x-4 tablet:gap-x-4 gap-y-4 mt-[32px]"></div>
                </div>
                <div className="w-full relative lg:h-full 2xl:h-[68%] 2xl:w-auto border-0 2xl:border-4 border-primary -mr-0 2xl:-mr-[2vw]">
                  <div className="2xl:h-[100%]   xl:border-l-8 2xl:border-l-0 border-primary special-image-effect">
                    <div className="flex w-full rectangle  h-[250px] md:h-[400px] xl:h-[500px] 2xl:h-[100%]  justify-center items-center bg-secondary opacity-20  duration-[0] ease-in-out object-cover">
                      <Loadingnovel />
                    </div>
                  </div>
                </div>
              </div>
            );
          })
        : specialNovel.novels?.map((special) => {
            return (
              <div key={special?._id}>
                <SpecialNovel
                  special={special}
                  setInterfaces={setInterfaces}
                  setPopUp={setPopUp}
                />
              </div>
            );
          })}
    </div>
  );
}

export default SpecialForYou;
